module.exports = __webpack_public_path__ + "static/media/ebay.706ab47c.svg";